import { Injectable } from '@angular/core';
import tinycolor from 'tinycolor2';
import { LoginDetailsService } from './login-details.service';


export interface ThemeData {
  ViejasStyle : Record<string, string>
}
export interface Color {
  name: string;
  hex: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeDataService {
  private parentKeys = ['primaryButtonStyle'];
  colorPalette;

  private keyMap: Record<string, string> = {
    'table-text-primary-color': 'fg',
    'table-text-secondary-color': 'fg-label',
    'auxiliary1-text-color': 'fg1',
    'auxiliary2-text-color': 'fg2',
    'section-tab-bar-color': 'section-bg',
    'selected-section-color': 'section-active',
    'accent-color': 'icon',
    'category-tint': 'separator',
    'entry-style-configuration-entry-background-color': 'card-bg',
    'entry-style-configuration-entry-border-color': 'card-bdr',
    'segment-control-configuration-selected-segment-background-color': 'segment-active-bg',
    'segment-control-configuration-selected-segment-title-color': 'segment-active-fg',
    'segment-control-configuration-un-selected-background-color': 'segment-bg',
    'segment-control-configuration-un-selected-segment-title-color': 'segment-fg',
    'background-color': 'bg',
    'text-color': 'fg',
    'border-color': 'bdr',
    'primary-button-style-background-color-in-hex': 'pri-btn-bg',
    'primary-button-style-text-color-in-hex': 'pri-btn-fg',
    'primary-button-style-border-color-in-hex': 'pri-btn-bdr',
    'secondary-button-style-background-color-in-hex': 'sec-btn-bg',
    'secondary-button-style-text-color-in-hex': 'sec-btn-fg',
    'secondary-button-style-border-color-in-hex': 'sec-btn-bdr',
    'content-background-color': 'content-bg',
    'tertiary-button-style-background-color-in-hex': 'ter-btn-bg',
    'tertiary-button-style-text-color-in-hex': 'ter-btn-fg',
    'tertiary-button-style-border-color-in-hex': 'ter-btn-bdr',
    // 'nav-bar-action-tint': '#ffffff'
  }

  constructor(private loginDetailsService: LoginDetailsService) { }

  private createVariables(theme: Record<string, any>,nestedkey: string = ''): void {
    Object.entries(theme).forEach(([key, value]) => {
      const kebabVar = `${this.pascalToKebab(key)}`;
      const newkeyVar = nestedkey ? `${nestedkey}-${kebabVar}`:kebabVar;
      const customProp = this.keyMap[newkeyVar] || newkeyVar;

      if(typeof value === 'object' && value !==null) {
        this.createVariables(value,newkeyVar);
      } else {
        document.documentElement.style.setProperty(`--pp-${customProp}`, value);
        if(this.checkforMappedKeys(key, nestedkey)) {
          this.colorPalette = this.computeColors(value);
          for (const color of this.colorPalette) {
            const key1 = `--pp-pri-${color.name}`;
            const value1 = color.hex;
            document.documentElement.style.setProperty(key1, value1);
          }
        }

      }
    });
  }

  private checkforMappedKeys(key: string, parentKey: string): boolean {
    const modifiedParentKey = parentKey.replace(/-([a-z])/g, (_, char) => char.toUpperCase())
    return key == 'BackgroundColorInHex' && this.parentKeys.includes(modifiedParentKey);
  }

  private pascalToKebab(str: string): string {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2') // convert camelCase
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2') // convert pascal case
    .toLowerCase();
  }

  computeColors(hex: string) {
    return [
      this.getColorObject(tinycolor(hex).lighten(35), '100'),
      this.getColorObject(tinycolor(hex).lighten(30), '200'),
      this.getColorObject(tinycolor(hex).lighten(24), '300'),
      this.getColorObject(tinycolor(hex).lighten(20), '400'),
      this.getColorObject(tinycolor(hex).lighten(12), '500'),
      this.getColorObject(tinycolor(hex).lighten(6), '600'),
      this.getColorObject(tinycolor(hex), '700'),
      this.getColorObject(tinycolor(hex).darken(11), '800'),
      this.getColorObject(tinycolor(hex).darken(18), '900'),
    ];
  }


  getColorObject(value, name): Color {
    const c = tinycolor(value);
    return {
      name: name,
      hex: c.toHexString(),
      // darkContrast: c.isLight(),
    };
  }

  applyApplicationThemingStyles() {
    let appThemingStyle = this.loginDetailsService.appThemingStyle;
    this.createVariables(this.loginDetailsService.mvStyle);

    // set the Application theme styles
    if(appThemingStyle.toLowerCase() === 'dark') {
      document.body.classList.remove('ppLightTheme');
      document.body.classList.add('ppDarkTheme');
      document.body.classList.add('darkTheme');
    } else {
      document.body.classList.remove('ppDarkTheme');
      document.body.classList.remove('darkTheme');
      document.body.classList.add('ppLightTheme');
    }
  }
}
